import { useGetSettingsQuery } from 'app/api_v2/settings/queries';
import { useEffect, useState } from 'react';

import { Box, Button, Card, CardContent, Typography } from '@mui/material';

import OverlayContent from './OverlayContent';

export default function GeneralInfoOverlay() {
  const { isSuccess, data, error } = useGetSettingsQuery();
  const [open, setOpen] = useState(() => false);

  const handleDismiss = () => {
    localStorage.setItem(data?.generalPopup?.localStorageKey || '', 'true');
    setOpen(false);
  };

  useEffect(() => {
    if (isSuccess && data && data.generalPopup && data.generalPopup.isActive) {
      // Handle successful data fetching
      setOpen(localStorage.getItem(data.generalPopup.localStorageKey) !== 'true');
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (isSuccess && data && data.generalPopup && data.generalPopup.isTestMode) {
      // test mode for admins
      setOpen(true);
    }
  }, [data?.generalPopup?.isTestMode, isSuccess]);

  useEffect(() => {
    if (error) {
      console.error('Error fetching settings:', error);
    }
  }, [error]);

  if (!open) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(33, 58, 109, 0.75)',
        zIndex: 9000,
      }}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box maxWidth={700} sx={{ overflowY: 'auto', maxHeight: '99vh', mx: 1 }}>
        <Card>
          <CardContent>
            <Box textAlign="center">
              <Typography variant="h2">{data?.generalPopup?.title}</Typography>
            </Box>
            <OverlayContent data={data?.generalPopup?.content} />
            <Box width="100%" display="flex" justifyContent="center">
              <Button variant="contained" color="primary" onClick={handleDismiss} disableElevation>
                {data?.generalPopup?.buttonText || 'Got it'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
